interface CookieSettings {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
}

// Get consent status
export const getCookieConsent = (): string | null => {
  return localStorage.getItem('cookieConsent');
};

// Get cookie settings
export const getCookieSettings = (): CookieSettings => {
  const settings = localStorage.getItem('cookieSettings');
  if (settings) {
    return JSON.parse(settings);
  }
  return {
    necessary: true,
    analytics: false,
    marketing: false
  };
};

// Check if a specific type of cookie is allowed
export const isCookieAllowed = (type: keyof CookieSettings): boolean => {
  // Necessary cookies are always allowed
  if (type === 'necessary') return true;
  
  const consent = getCookieConsent();
  
  // If the user has given full consent, all cookies are allowed
  if (consent === 'full') return true;
  
  // For custom consent, check the specific setting
  if (consent === 'custom') {
    const settings = getCookieSettings();
    return settings[type] || false;
  }
  
  // If no consent given, only necessary cookies are allowed
  return false;
};

// Reset cookie consent (for testing)
export const resetCookieConsent = (): void => {
  localStorage.removeItem('cookieConsent');
  localStorage.removeItem('cookieSettings');
};

// Examples of cookie usage functions
export const setAnalyticsCookies = (): void => {
  if (isCookieAllowed('analytics')) {
    // Code to set analytics cookies would go here
    console.log('Analytics cookies set');
  }
};

export const setMarketingCookies = (): void => {
  if (isCookieAllowed('marketing')) {
    // Code to set marketing cookies would go here
    console.log('Marketing cookies set');
  }
}; 